import { PropsWithChildren } from "react";
import HeaderActions from "./actions";
import HeaderFilters from "./filters";

export interface HeaderProps extends PropsWithChildren{
    
}

export default function ListPageHeader({ 
    children,
}:HeaderProps){
    return <>
        {children}
    </>
}

ListPageHeader.Actions = HeaderActions;
ListPageHeader.Filters = HeaderFilters;